import OutlineCalendarIcon from 'heroicons/outline/calendar.svg'
import OutlineAdjustmentsIcon from 'heroicons/outline/adjustments.svg'
import OutlineSortAscendingIcon from 'heroicons/outline/sort-ascending.svg'
import OutlineSortDescendingIcon from 'heroicons/outline/sort-descending.svg'
import OutlineInformationCircleIcon from 'heroicons/outline/information-circle.svg'
import OutlinePencilAltIcon from 'heroicons/outline/pencil-alt.svg'
import OutlinePlusIcon from 'heroicons/outline/plus.svg'
import OutlineZoomInIcon from 'heroicons/outline/zoom-in.svg'
import OutlineZoomOutIcon from 'heroicons/outline/zoom-out.svg'
import OutlineTicketIcon from 'heroicons/outline/ticket.svg'
import OutlineShareIcon from 'heroicons/outline/share.svg'
import OutlineViewGridIcon from 'heroicons/outline/view-grid.svg'
import OutlineViewGridAddIcon from 'heroicons/outline/view-grid-add.svg'
import OutlineEyeIcon from 'heroicons/outline/eye.svg'
import OutlineEyeOffIcon from 'heroicons/outline/eye-off.svg'
import OutlineTrashIcon from 'heroicons/outline/trash.svg'
import OutlineDocumentIcon from 'heroicons/outline/document.svg'
import OutlineDocumentAddIcon from 'heroicons/outline/document-add.svg'
import OutlineClipboardCheckIcon from 'heroicons/outline/clipboard-check.svg'
import OutlineClipboardListIcon from 'heroicons/outline/clipboard-list.svg'
import OutlineDownloadIcon from 'heroicons/outline/download.svg'
import OutlineDocumentDownloadIcon from 'heroicons/outline/document-download.svg'
import OutlineExternaLinkIcon from 'heroicons/outline/external-link.svg'
import OutlineSearchCircleIcon from 'heroicons/outline/search-circle.svg'
import OutlineSearchIcon from 'heroicons/outline/search.svg'
import OutlineDocumentSearchIcon from 'heroicons/outline/document-search.svg'

const outline = {
  OutlineDocumentSearchIcon,
  OutlineSearchCircleIcon,
  OutlineSearchIcon,
  OutlineExternaLinkIcon,
  OutlineCalendarIcon,
  OutlineAdjustmentsIcon,
  OutlineSortAscendingIcon,
  OutlineSortDescendingIcon,
  OutlineInformationCircleIcon,
  OutlinePencilAltIcon,
  OutlinePlusIcon,
  OutlineZoomInIcon,
  OutlineZoomOutIcon,
  OutlineTicketIcon,
  OutlineShareIcon,
  OutlineViewGridIcon,
  OutlineViewGridAddIcon,
  OutlineEyeIcon,
  OutlineEyeOffIcon,
  OutlineTrashIcon,
  OutlineDocumentIcon,
  OutlineDocumentAddIcon,
  OutlineClipboardCheckIcon,
  OutlineClipboardListIcon,
  OutlineDownloadIcon,
  OutlineDocumentDownloadIcon,
}

import SolidPlusIcon from 'heroicons/solid/plus.svg'
import SolidMinusIcon from 'heroicons/solid/minus.svg'
import SolidDocumentSearchIcon from 'heroicons/solid/document-search.svg'
import SolidFolderOpenIcon from 'heroicons/solid/folder-open.svg'
import CopiaVirtualIcon from './img/copiar-virtual.svg'

const solid = {
  SolidPlusIcon,
  SolidMinusIcon,
  SolidDocumentSearchIcon,
  SolidFolderOpenIcon,
}

import SubdirectoryRightIcon from 'zondicons/subdirectory-right.svg'

const custom = {
  SubdirectoryRightIcon,
  CopiaVirtualIcon
}

const icons = {
  ...solid,
  ...outline,
  ...custom,
}

export default icons
